
const contents = "query MultiTenantOrganizationDetailsClients {\n  viewer {\n    multiTenantHubNetwork {\n      id\n      displayName\n      isMultiTenantNetwork\n      tenantId\n    }\n  }\n}\n";
const sha256Hash = "d9de68ef930931d5a50d2cb39a472069be7806c78043f52b06caee611473c6cd";
export default { contents: contents, sha256Hash: sha256Hash };
